export enum SupportedCountry {
    AU = 'Australia',
    NZ = 'New Zealand',
    JP = 'Japan',
    IN = 'India'
}

export const {AU, NZ, JP, IN} = SupportedCountry;
